import React from "react";
import {i18n} from "translate/i18n";
import ReactPaginate from "react-paginate";

const PaginationTable = ({
                     paginate,
                     handlePageClick,
                     isFetching = false
}) => {

    const totalItems = paginate.total ? paginate.total : 0;
    const totalPages = Math.ceil(totalItems / 15);

    return (
        <div className="row mt-3 mx-1">
            <div className="col-xs-12 col-md-6 mb-3">
                <span className="text-muted text-sm ">
                    {i18n.t('table.showing')}
                    {paginate?.from ? paginate?.from : 0}
                    {i18n.t('table.to')}
                    {paginate?.to ? paginate?.to : 0}
                    {i18n.t('table.of')}
                    {paginate?.total}
                    {i18n.t('table.records')}
                </span>
                {isFetching &&
                    <div className="spinner-border spinner-border-sm text-theme ms-4" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                }
            </div>
            <div className="col-xs-12 col-md-6">

                <div className="float-md-end">
                    <ReactPaginate
                        previousLabel={
                            <>
                                <span className="d-none d-sm-block">{i18n.t('table.previous')}</span>
                                <span className="d-block d-sm-none"><i className="bi bi-chevron-left"/></span>
                            </>
                        }
                        nextLabel={
                            <>
                                <span className="d-none d-sm-block">{i18n.t('table.next')}</span>
                                <span className="d-block d-sm-none"><i className="bi bi-chevron-right"/></span>
                            </>
                        }
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakLabel="..."
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={totalPages}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName="pagination"
                        activeClassName="active"
                    />
                </div>
            </div>
        </div>
    )
}

export default PaginationTable
